import {useState} from "react";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import {Button, Input, LoginBox, LoginContainer, Title} from "../../signatures/loginSignatures/styles";

const LoginChargeback:React.FC = () => {
  const [password, setPassword] = useState('');
  const history = useHistory();
  const predefinedPassword = '7!A!G*6;aZ4-..zbQ)k';

  const handleLogin = () => {
    if(password === predefinedPassword){
      history.push('/admin/chargeback')
    }else {
      toast.error('Senha incorreta!');
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Title>Login Chargeback</Title>
          <Input
            type='password'
            placeholder='Insira a senha'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginChargeback;
